import * as React from "react";

const SvgComponent = ({ color = "#5F00BE" }) => (
  <svg width="76.000000" height="76.000000" viewBox="0 0 76 76" fill="none">
    <defs>
      <clipPath id="clip1505_1008">
        <rect id="Frame" width="76.000000" height="76.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="76.000000" height="76.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1008)">
      <path
        id="Vector"
        d="M13 70C13 55.9043 24.1914 44.4766 38 44.4766C51.8086 44.4766 63 55.9043 63 70L56.75 70C56.75 59.4277 48.3555 50.8574 38 50.8574C27.6445 50.8574 19.25 59.4277 19.25 70L13 70ZM38 41.2852C27.6406 41.2852 19.25 32.7188 19.25 22.1426C19.25 11.5664 27.6406 3 38 3C48.3594 3 56.75 11.5664 56.75 22.1426C56.75 32.7188 48.3594 41.2852 38 41.2852ZM38 34.9043C44.9062 34.9043 50.5 29.1934 50.5 22.1426C50.5 15.0918 44.9062 9.38086 38 9.38086C31.0938 9.38086 25.5 15.0918 25.5 22.1426C25.5 29.1934 31.0938 34.9043 38 34.9043Z"
        fill={color}
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
      <path
        id="Vector 286 (Stroke)"
        d="M60 70L17 70L17 64L60 64L60 70Z"
        fill={color}
        fill-opacity="1.000000"
        fill-rule="evenodd"
      />
    </g>
  </svg>
);

export default SvgComponent;
